// generate a random int between min (inclusive) and max (inclusive)
const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

export default random;
